import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { EditIcon } from "../../../ui/icons/edit"
import { TrashIcon } from "../../../ui/icons/trash"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { formatterDate, optionsFormatter, revisioneOptions, typologyOptions } from "../../../utils"
import { GetByIdPersonalManagement, resetGetByIdPersonalManagementResourcesStatus } from "../slice"
import { ContrattiPopupAdd } from "./boxPopupOptions/add"
import { ContrattiPopupEdit } from "./boxPopupOptions/edit"
import { ContractDTO } from "./dataService/dto"
import { addContracts, ContractDelete, GetContractById, resetContractCreationRequest, resetContractDeleteStatus, resetContractErrors, resetContracts, resetContractUpdateRequest, resetGetContractByIDStatus, setContractIdToUpdate, setPMId, setUpdateActive, setUpdateContractType, setUpdateEndingDate, setUpdateKmIndennity, setUpdateNumContract, setUpdatePMId, setUpdateProtocolIdDeparture, setUpdateRevisionType, setUpdateStartingDate, setUpdateStipulate } from "./slice"

export function BoxContratti() {
    const dispatch = useAppDispatch()
    const contractsState = useAppSelector(state => state.PMContracts)
    const PMState = useAppSelector(state => state.personalManagement)
    const [openPopup, setOpenPopup] = useState<boolean>(false)
    const [openPopupEdit, setOpenPopupEdit] = useState<boolean>(false)

    const onEditHandler = (contract: ContractDTO) => {
        dispatch(setUpdateProtocolIdDeparture(contract.protocolIdDeparture))
        dispatch(setUpdatePMId(contract.personalManagementId))
        dispatch(setUpdateActive(contract.active))
        dispatch(setUpdateKmIndennity(contract.kmIndennity))
        dispatch(setUpdateEndingDate(contract.ending))
        dispatch(setUpdateStartingDate(contract.starting))
        dispatch(setUpdateStipulate(contract.stipulate))
        dispatch(setUpdateRevisionType(contract.revisionType))
        dispatch(setUpdateNumContract(contract.numContract))
        dispatch(setUpdateContractType(contract.contractType))
        dispatch(setContractIdToUpdate(contract.id))
        setOpenPopupEdit(true)
    }

    useEffect(() => {
        if (PMState.currentPersonalManagementId) {
            dispatch(setPMId(PMState.currentPersonalManagementId))
            dispatch(setUpdatePMId(PMState.currentPersonalManagementId))
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
        }
    }, [])

    useEffect(() => {
        dispatch(resetContracts())
        if (
            PMState.getByIdPersonalManagementResourcesStatus === 'successfully' &&
            PMState.getByIdPersonalManagementResourcesResponse?.contractIds
        ) {
            dispatch(resetGetByIdPersonalManagementResourcesStatus('idle'))
            for (let index = 0; index < PMState.getByIdPersonalManagementResourcesResponse.contractIds.length; index++) {
                dispatch(GetContractById(PMState.getByIdPersonalManagementResourcesResponse.contractIds[index].toString()))
            }
        }
    }, [PMState.getByIdPersonalManagementResourcesStatus])

    useEffect(() => {
        if (
            contractsState.getContractByIdStatus === 'successfully' &&
            contractsState.getContractByIdResponse !== undefined
        ) {
            dispatch(resetGetContractByIDStatus())
            dispatch(addContracts(contractsState.getContractByIdResponse))
        }
    }, [contractsState.getContractByIdStatus])

    useEffect(() => {
        if (contractsState.contractDeleteStatus === 'successfully') {
            dispatch(resetContractDeleteStatus())
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
        }
    }, [contractsState.contractDeleteStatus])

    return (
        <div className="p-6">
            <div className="space-y-3">
                <div className="flex items-center justify-between">
                    <span className="font-bold text-2xl text-neutral-850">Contratti</span>
                    <ButtonComponent
                        size="md"
                        iconPosition="off"
                        variant="solid"
                        color="orange"
                        label="Aggiungi contratto"
                        onClick={() => setOpenPopup(true)}
                    />
                </div>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-text-md min-w-[900px]">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Tipologia</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Revisione</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Stipula</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Inizio</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Fine</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Partenza</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[72px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {contractsState.contracts.length === 0 ? (
                                <tr>
                                    <td colSpan={7} className="px-3 py-3 text-left text-neutral-500 bg-white">
                                        Nessun contratto trovato
                                    </td>
                                </tr>
                            ) : (
                                contractsState.contracts.map((contract, index) => (
                                    <tr
                                        key={contract.id}
                                        className={`text-left border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {`${optionsFormatter(contract.contractType, typologyOptions)} n. ${contract.numContract}`}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {optionsFormatter(contract.revisionType, revisioneOptions)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(contract.stipulate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(contract.starting)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {formatterDate(contract.ending!)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {contract.protocolIdDeparture}
                                        </td>
                                        <td className="px-3 py-2 w-[72px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => onEditHandler(contract)}
                                                >
                                                    <EditIcon color={"Orange"} size={18} />
                                                </button>
                                                <button
                                                    className="p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => dispatch(ContractDelete(contract.id!))}
                                                >
                                                    <TrashIcon color={"Orange"} size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {openPopup && (
                <PopupForm title="Aggiungi Contratto" close={() => {
                    dispatch(resetContractErrors())
                    dispatch(resetContractCreationRequest())
                    setOpenPopup(false)
                }}>
                    <ContrattiPopupAdd close={() => setOpenPopup(false)} />
                </PopupForm>
            )}

            {openPopupEdit && (
                <PopupForm title="Modifica Contratto" close={() => {
                    dispatch(resetContractUpdateRequest())
                    dispatch(resetContractErrors())
                    setOpenPopupEdit(false)
                }}>
                    <ContrattiPopupEdit close={() => setOpenPopupEdit(false)} />
                </PopupForm>
            )}
        </div>
    )
}